var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useEffect } from "react";
import { waitForSelector } from "../lib/waitForSelector";
var POSITION_STYLES = {
    "center-right": {
        // legacy, same as "right"
        right: 0,
        top: "50%",
        transformOrigin: "bottom right",
        transform: "rotate(270deg) translateX(75%)",
        borderRadius: "4px 4px 0 0",
    },
    right: {
        // same as "center-right"
        right: 0,
        top: "50%",
        transformOrigin: "bottom right",
        // unforunately, we cannot specify multiple transformOrigin, so if we translateX by 50% we will be off-center
        // and this is noticeable in the success screen. Applies to right, left.
        transform: "rotate(270deg) translateX(75%)",
        borderRadius: "4px 4px 0 0",
    },
    left: {
        left: 0,
        top: "50%",
        transformOrigin: "bottom left",
        transform: "rotate(90deg) translateX(-75%)",
        borderRadius: "4px 4px 0 0",
    },
    bottom: {
        bottom: 0,
        left: "50%",
        transform: "translateX(-50%)",
        borderRadius: "4px 4px 0 0",
    },
    top: {
        top: 0,
        left: "50%",
        transform: "translateX(-50%)",
        borderRadius: "0 0 4px 4px",
    },
};
export var RibbonLabel = function (_a) {
    var attachedToExistingSelector = _a.attachedToExistingSelector, ribbonLabel = _a.ribbonLabel, handleWidgetClick = _a.handleWidgetClick, primaryColor = _a.primaryColor, secondaryColor = _a.secondaryColor, anchorPosition = _a.anchorPosition;
    useEffect(function () {
        // attach to existing element if selector is provided
        if (!attachedToExistingSelector) {
            return;
        }
        var handler = function (e) {
            // IMPORTANT: this is a native HTML event, not a React synthetic event
            var _a, _b, _c;
            (_a = e.preventDefault) === null || _a === void 0 ? void 0 : _a.call(e);
            (_b = e.stopPropagation) === null || _b === void 0 ? void 0 : _b.call(e);
            (_c = e.stopImmediatePropagation) === null || _c === void 0 ? void 0 : _c.call(e);
            handleWidgetClick();
        };
        var cleanup = waitForSelector(attachedToExistingSelector, function (element) {
            element.addEventListener("click", handler);
        }, function (element) {
            var _a;
            (_a = element === null || element === void 0 ? void 0 : element.removeEventListener) === null || _a === void 0 ? void 0 : _a.call(element, "click", handler);
        });
        return function () {
            cleanup();
        };
    }, [attachedToExistingSelector, handleWidgetClick]);
    if (attachedToExistingSelector) {
        // if we are attached to an existing element, we don't need to render the ribbon
        return null;
    }
    return (React.createElement("div", { className: "font-sans min-h-[25px] h-fit w-fit overflow-hidden\n        ease-in-out cursor-pointer flex flex-col items-center justify-center pointer-events-none select-none bg-transparent opacity-60 hover:opacity-90 transition-opacity duration-300", style: __assign({ position: "fixed" }, POSITION_STYLES[anchorPosition]) },
        React.createElement("button", { type: "reset", onClick: handleWidgetClick, className: "flex w-full h-full items-center justify-center whitespace-nowrap font-medium outline-2 drop-shadow-sm uppercase bg-zinc-900 text-zinc-50 shadow-md px-3 py-1.5 text-xs pointer-events-auto", style: __assign(__assign({}, (secondaryColor !== "#FFFFFF" && {
                color: secondaryColor,
            })), (primaryColor !== "#000000" && {
                backgroundColor: primaryColor,
            })) }, ribbonLabel)));
};
